<template>
    <div >

        <div style="z-index: 100; position: absolute; width: 100%">
            <van-list
            >
                <van-cell
                        style="padding: 10px 0;"
                        v-for="item in goodsArray"
                        @click="$router.push('goods/'+item.id)"
                >
                    <van-card
                            :title="item.title"
                            desc="5.99英寸高清全面大屏，智能柔光自拍，高清后置双摄，全新IMT外观工"
                            :thumb="item.picture"
                    >
                        <div slot="tags" style="color: #f44;font-size: 12px; font-weight: 900">
                            ￥{{item.price}}
                        </div>
                        <div slot="footer"  style="color: #666;font-size: 12px; right: 0;    margin-top:-25px">
                            <span style="padding: 3px; border: 1px solid #aaa; color: #aaa;  border-radius: 3px " v-if="item.isHave">有货</span>
                            <span style="padding: 3px; border: 1px solid #f66; color: #f66;  border-radius: 3px " v-else>售罄</span>
                            <span style="margin-left: 10px; background: #eee; color: #999; padding: 3px; border-radius: 3px " v-text="item.shopName"> 金怡佳</span>
                        </div>
                    </van-card>
                </van-cell>
            </van-list>

        </div>
    </div>
</template>

<script>
  export default {
    props: {
      goodsArray: Array
    },
    data() {
      return {
        active: ''
      }
    },
    watch: {
      active (active) {

      }
    }
  }
</script>

<style lang="less">

</style>